import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/ds-react-utils";
import { CheckboxField } from "@kaltura/mediaspace-shared-ui/controlled-form";
import { Box } from "@mui/material";

const Checkbox = styled(CheckboxField)`
    // for some reason, the checkbox field has a huge margin top by default.
    // and this form already has a flex gap, so no need for a margin at all.
    margin-top: 0;
`;

export const DVR = () => {
    return (
        <Checkbox
            id="enableDvr"
            label={translate("Enable DVR")}
            description={translate(
                "Allow seeking to previous parts of the live stream. The DVR window is 24 hours by default."
            )}
        />
    );
};
